module.exports = __webpack_public_path__ + "static/media/leaves_1.f610bd8f.png";